import { render, staticRenderFns } from "./addwithadditional.vue?vue&type=template&id=273586c9&"
import script from "./addwithadditional.vue?vue&type=script&lang=js&"
export * from "./addwithadditional.vue?vue&type=script&lang=js&"
import style0 from "./addwithadditional.vue?vue&type=style&index=0&id=273586c9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports